import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import client from "../api";
import { notifyError } from "../helper";
import BlockLoader from "./BlockLoader";


const VariableSelectBox = (props) => {
    const {campaignID} = useParams('');
    const api = client();
    const [itemLoader, setItemLoader] = useState(true);
    const [toggleVariableList,setToggleVariableList] = useState(false);
    const [variableListItems,setVariableListItems] = useState([]);
    
    const copyTextArea = (item) => {
        let copyItem = '{{'+item+'}}';
        props.handleInsertAtCursor(copyItem);
        setToggleVariableList(false);
    }

    useEffect(()=>{
        const getValiableItems = async () => {
          try{
            setItemLoader(true);
            const response = await api.post('/v1/campaign/emailVariables/get',{
              campaignID:campaignID
            });
            if(response.status === 200 || response.status === 201){
                setVariableListItems(response.data.data.list_data_keys);
                setItemLoader(false);
            }
          } catch (error){
            console.log('error.message',error);
            setItemLoader(false);
            if(error.status === 400) notifyError('Bad Request. Unable to fetch variable list. Please try again');            
          } finally {
            setItemLoader(false);
          }
        }
        getValiableItems();
      },[]);
    
    return(
        <div className="select-box">
            <button 
                type="button"
                className="variable-btn"
                onClick={()=>{
                    setToggleVariableList(!toggleVariableList)
                }}>
                Insert
            </button>
            <ul className={toggleVariableList ? `variable-list open`:`variable-list`}>
                { itemLoader ? <><BlockLoader /></>:<>
                {variableListItems.map((item,i)=>(<li key={i} onClick={()=>copyTextArea(item)}>{item}</li>))}
                <li onClick={()=>copyTextArea('unsubscribe_url')}>unsubscribe_url</li>
                </> } 
            </ul>
        </div>
    );
}

export default VariableSelectBox;